// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardContentItem_wrapper__3tmGK","label":"CardContentItem_label__2v7iR","value":"CardContentItem_value__GURd4"};